export default __webpack_public_path__ + "static/media/insights_background_right.d9518077.png";